export enum BookEventSlotStep {
  CHOOSE_TICKET_CATEGORY = 'CHOOSE_TICKET_CATEGORY',
  CHOOSE_SLOT = 'CHOOSE_SLOT',
  PERSONAL_DATA = 'PERSONAL_DATA',
  PAYMENT = 'PAYMENT',
}
